import { ILevelGroupRequestModel } from '../../models/requests/LevelGroupRequestModel'
import { ILevelGroupModel } from '../../models/responses/LevelGroupModel'
import { PagedResponseModel } from '../../models/responses/PagedResponseModel'
import { IPaginationFilter, generateQueryParams } from '../../models/requests/PaginationFilter'
import API from './Api'

class LevelGroupApi {

  async GetLevelGroups(filter: IPaginationFilter) {
    return await API.get<PagedResponseModel<ILevelGroupModel[]>>(`e/Admin/LevelGroups${generateQueryParams(filter)}`)
  }

  async GetLevelGroup(id: number) {
    return await API.get<ILevelGroupModel>('e/Admin/LevelGroups/' + id)
  }

  async AddLevelGroup(model: ILevelGroupRequestModel) {
    return await API.post('e/Admin/LevelGroups', model)
  }

  async UpdateLevelGroup(model: ILevelGroupRequestModel) {
    return await API.put('e/Admin/LevelGroups/' + model.id, model)
  }

  async DeleteLevelGroup(itemId: number) {
    return await API.delete<boolean>('e/Admin/LevelGroups/' + itemId)
  }
}

export default new LevelGroupApi()
